import { render, staticRenderFns } from "./XKFOrder.vue?vue&type=template&id=ee7e75ba&scoped=true&"
import script from "./XKFOrder.vue?vue&type=script&lang=js&"
export * from "./XKFOrder.vue?vue&type=script&lang=js&"
import style0 from "./XKFOrder.vue?vue&type=style&index=0&id=ee7e75ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7e75ba",
  null
  
)

export default component.exports